const AppConfig = {
  baseUrl: "https://medideals.infinydev.com/",
  // baseUrl: 'https://api.medideals.in/',
  // baseUrl: 'http://localhost:4002/',
  productImageUrl: "https://s3.ap-south-1.amazonaws.com/medideals.assets/",
};

export default AppConfig;
